/* eslint-disable no-unused-vars */
import { useEffect,useState } from 'react';
import { useSelector } from 'react-redux';

import { selectLang } from '../Contexts/lang/langueSlice';
import { addEuro, isNumber } from '../Utils/utils';

function formatNumberByLocal(number, language) {
    if (language === 'en') return number;

    const options = {
        //        style: 'decimal',
        minimumFractionDigits: 1,
        maximumFractionDigits: 2,
    };

    if (language === 'fr') {
        // Set the French formatting options with a comma as the decimal separator
        options.useGrouping = true;
        options.minimumFractionDigits = 1;
        options.maximumFractionDigits = 1;
        options.minimumIntegerDigits = 2;
    } else {
        // Default to English formatting with a period as the decimal separator
        options.useGrouping = false;
    }

    if (!isNumber(number)) return number;

    // Custom formatting function
    const customFormat = (num) => {
        // const [integerPart, decimalPart] = num.toString().split('.');
        const fixed = Number(num).toFixed(2); // toujours 2 décimales
        const [integerPart, decimalPart] = fixed.split('.');
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

        return decimalPart ? `${formattedInteger},${decimalPart}` : formattedInteger;
    };

    return customFormat(number);
    /**
     * // *
   // return number.toLocaleString(language, options);
   // *
   // List of locales representing different countries
   const locales = {
       en1 :'en-US',//Number 1: 1,234,567.89
       en2:'pt-BR',
       en:'en-IN',
       // eslint-disable-next-line no-irregular-whitespace
       fr:'fr-FR', //Number 1: 1234567,89
       de:'de-DE',//Number 1: 1.234.567,89
       es:'es-ES',//Number 1: 1.234.567,89
       ja:'ja-JP'//Number 1: 1,234,567.89
   };
   // Create a formatter with the current locale
   const formatter = new Intl.NumberFormat(locales[language]);
   return formatter.format(number);
   // *
   //result 123,233.12
   // Number(parseFloat(3000).toFixed(2)).toLocaleString('en', {
   //     minimumFractionDigits: 2
   // });
   // *
   // return parseFloat(parseFloat(value).toFixed(decimal)).toLocaleString(
   //     "en-IN",
   //     {
   //       useGrouping: true,
   //     }
   //   );
     */
}

export function useNumberFormatting(defaultLanguage) {
    // ! I disactivate this feature of selecting language for now
    // const detectedLanguage = useSelector(selectLang);
    const detectedLanguage = 'fr'; // Replace with your language detection logic
    const [userLanguage, setUserLanguage] = useState(defaultLanguage);

    useEffect(() => {
    // You should replace this logic with your language detection method
    // For example, using browser settings or user preferences
        console.log(detectedLanguage);
        setUserLanguage(detectedLanguage);
    }, [detectedLanguage]);

    function formatNumber(number) {
        // console.log(detectedLanguage, number, typeof number, formatNumberByLocal(number, 'fr'));
        // return formatNumber(number, 'fr');
        if(typeof number === 'string' && isNumber(number)){
            // console.log(Number(number), formatNumberByLocal(Number(number), userLanguage),
            //     // formatNumber(Number(number), userLanguage).replace(/\s/g,''),
            //     isNumber(number),
            //     // !isNaN(formatNumber(Number(number), userLanguage).replace(/\s/g,''))
            // );
            return formatNumberByLocal(Number(number), 'fr' ?? userLanguage);
        }
        else if (typeof number === 'number' && !isNaN(number)) {
            number = number.toFixed(2);
            return formatNumberByLocal(Number(number), 'fr' ?? userLanguage);
            // return formatNumberByLocal(number, 'fr' ?? userLanguage);
        }
        else return number;
    }

    function addEuro4Decimal(value, unit='€') {
        return addEuro(formatNumber(value),unit);
        // * the normal functioning of addEuro (the old one)
        // return addEuro(value,unit);
    }

    return { formatNumber, addEuro4Decimal };
}
